import { lazy } from 'react';

export const NewsDetailPageAsync = lazy(() => import('./NewsDetailPage'));
